import React from "react";

export const burgerBarsCollapseLeft = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        fill="currentColor"
        d="M3 6h14v2H3zm0 5h10v2H3zm0 5h14v2H3zM21 15.148l-3.709-3.443L21 8.263l-1.142-1.058-4.858 4.5 4.858 4.5z"
      />
    </svg>
  );
};
